import { render, staticRenderFns } from "./reservation-detail.vue?vue&type=template&id=35a9c3ae&"
import script from "./reservation-detail.vue?vue&type=script&lang=js&"
export * from "./reservation-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports